module.exports = __webpack_public_path__ + "1cd85251.png";